<template>
    <vue-collapsible-panel class="grey-container my-3" :class="{'inactive':!isActive}"
                           :expanded="expand"
    >
        <template #title class="is-flex is-align-content-space-between is-align-items-center">
            <div class="date is-flex is-flex-direction-column">
                {{ getWeekDay(date) }}, {{ formattedDay }}
            </div>
        </template>
        <template #content>
            <span class="placeholder">&nbsp;</span>
            <div class="list-header"
                 :class="{'hidden':hasFilter}"
                 v-if="mealsLunch.length > 0">
                <img src="@/assets/images/dish_icon.svg" alt="mittagsmenüs">
                Mittagsmenüs
            </div>
            <span v-for="meal of mealsLunch" :key="meal.id">
                <DayListItem :meal="meal" :isActive="isActive"/>
            </span>
            <div class="list-header"
                 :class="{'hidden':hasFilter}"
                 v-if="mealsSalad.length > 0">
                <img src="@/assets/images/salad_icon.svg" alt="salate & co.">
                Salate & Co.
            </div>
            <span v-for="meal of mealsSalad" :key="meal.id">
                <DayListItem :meal="meal" :isActive="isActive"/>
            </span>
        </template>
    </vue-collapsible-panel>
</template>

<script>
import {format, getDay, parseISO, isFuture, isToday} from 'date-fns'
import {VueCollapsiblePanel} from '@dafcoe/vue-collapsible-panel'
import DayListItem from '@/views/components/ui/PublicMenuPlan/DayListItem'

export default {
    name: 'PublicMenuPlanDayList',
    components: {
        VueCollapsiblePanel,
        DayListItem
    },
    props: [
        'mealsOfTheDay',
        'date',
        'filter',
        'expand',
    ],
    data() {
        return {
            weekDays: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
            formattedDay: '',
        }
    },
    computed: {
        mealsLunch() {
            return this.mealsOfTheDay.filter(meal =>
                meal.matchingFilters.includes('Menüs') && this.showMeal(meal)
            )
        },
        mealsSalad() {
            return this.mealsOfTheDay.filter(meal =>
                meal.matchingFilters.includes('Salate') && this.showMeal(meal)
            )
        },
        isActive() {
            return isFuture(parseISO(this.date)) || isToday(parseISO(this.date))
        },
        hasFilter() {
            return Array.isArray(this.filter) && this.filter.length > 0
        }
    },
    methods: {
        getWeekDay(date) {
            const day = parseISO(date)
            return this.weekDays[getDay(day)]
        },
        formatDate() {
            return format(parseISO(this.date), 'dd.MM.yyyy')
        },
        showMeal(meal) {
            if (!Array.isArray(this.filter) || this.filter.length === 0) {
                return true
            }

            if (this.filter.every(filter => meal.matchingFilters.includes(filter))) {
                return true
            }

            return false
        },
    },
    mounted() {
        this.formattedDay = this.formatDate()
    },
}
</script>

<style lang="scss" scoped>
.vcp__header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .date {
        width: 100%;

        .day-amount-container {
            flex-direction: column;

            @media all and (min-width: $mobile-xs) {
                flex-direction: row;
            }
        }
    }
}

.list-header {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: $grey;
    padding: 2rem 1rem;
    font-size: $font-size-large;

    img {
        margin-right: 1em;
    }

    &.hidden {
        display: none;
    }
}

.vcp {
    &.grey-container {
        transition: $transition-standard;

        @media all and (min-width: $mobile-xs) {
            padding: 5px 0;
        }

        &.inactive {
            color: $dark-grey;

            .list-header img {
                opacity: .25;
            }
        }

        .placeholder {
            display: block;
            height: 0;
        }

        &.error {
            border: 2px solid $warning-color;
        }
    }
}

@media all and (min-width: $desktop) {
    .desktop,
    .desktop-list {
        .list-header {
            padding: 0 1rem 1rem;
            width: 100%;
        }
    }
}
</style>
